<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// App组件的根组件，所有页面都会通过router-view渲染
</script>

<style scoped>
#app {
  min-height: 100vh;
  background-color: #f5f5f5;
}
</style>
